/* © CNES */
import OLVectorLayer from 'ol/layer/Vector';
import { useContext, useEffect } from 'react';
import MapContext from '../MapContext';

/**
 * Vector Layer
 * @param source source of Vector.
 * @param style style to apply to layer.
 * @param zIndex zIndex of the layer.
 * @returns null
 */
const VectorLayer = ({
  source,
  style,
  zIndex = 0,
}: {
  source: any;
  style: any;
  zIndex: number;
}) => {
  const { map } = useContext(MapContext);
  useEffect(() => {
    if (!map) return;
    let vectorLayer = new OLVectorLayer({
      source,
      style,
    });
    map.addLayer(vectorLayer);
    vectorLayer.setZIndex(zIndex);
    return () => {
      if (map) {
        map.removeLayer(vectorLayer);
      }
    };
  }, [map, source, style, zIndex]);
  return null;
};
export default VectorLayer;
